import API from 'aurora-api';
import * as urls from 'aurora-api/urls';
import { ACTIVE_URL } from 'aurora-utils/constants';

const { BASE_URL } = ACTIVE_URL;
const api = new API(BASE_URL);

class WalletService {
  static fetchWallet = () => api.get(urls.WALLET.BALANCE, null, null);

  static fetchTransactions = (body, params) => api.post(urls.PAYMENT.TRANSACTIONS, body, params);

  static fetchTransactionDetails = query => api.get(urls.WALLET.TRANSACTION_DETAILS, null, query);

  static payAmount = data => api.post(urls.WALLET.PAY_AMOUNT, data);
}

export default WalletService;
